module.exports = __webpack_public_path__ + "static/media/Santa Clara Street, Brisbane, CA1.2b3852fa.jpg";